import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const getDashboard = createApi({
 reducerPath: 'getDashboard',

 baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_DMT_API_PATH}`,
 }),

 endpoints: (builder) => ({
  copyright: builder.query({
   query: (id) => {
    return {
     url: `/admin/orders/copyright/${id}`,
     method: 'GET'
    }
   }
  }),
 }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {useCopyrightQuery}=getDashboard